<template>
  <div>
    <div class="container-fluid container-froDesk">
      <div class="wrapper">
        <div class="content-page content-froDesk">
          <div class="content">
            <div class="row">
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <div class="dropdown float-right">
                      <Breadcrumb id="projectApplication" :active="1"></Breadcrumb>
                    </div>
                    <h3 class="header-title froDeskHeader-tit mb-3 pb-2">
                      <span class="tit">详情</span>
                      <span class="ml-1">Details</span>
                    </h3>
                    <div class="General-details pb-3">
                      <h3 class="genDet-tit text-center mb-4 pt-3">{{ data.projectName }}</h3>
                      <div class="genDet-att text-muted text-center mb-4 pb-2">
                        <span class="p-2">课题类别：{{ data.projectTypeName }}</span>
                        <!-- <span class="p-2">项目编号：{{data.projectNumber}}</span> -->
                        <span class="p-2">发布日期：{{ data.createTime }}</span>
                      </div>
                      <div class="genDet-con" v-html="data.note"></div>
                      <div class="bottom_box">
                        <el-divider></el-divider>
                        <div class="data_info">
                          <p>
                            <span class="info_tit">课题级别：</span>
                            <span>{{ data.projectLevelName }}</span>
                          </p>
                          <p>
                            <span class="info_tit">申报截止日期：</span>
                            <span class="info_time">{{ data.declareEndTime&&data.declareEndTime.slice(0,-3) }}</span>
                          </p>
                          <template v-if="data.attachment && data.attachment.length">
                            <p v-for="(item, index) in data.attachment" :key="index">
                              <span class="info_tit">{{index==0?'附件：':''}}</span>
                              <span class="info_time" @click="downloadFile(item,data.annexName[index])">{{data.annexName[index]}}</span>
                            </p>
                          </template>
                        </div>
                        <el-divider></el-divider>
                        <div class="btn_box mt-3">
                          <el-button class="mb-1" :type="btnType" @click="toApplication">现在申报
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <el-dialog title="视频预览" :visible.sync="filePreviewDialogVisible" width="50%" :before-close="closePreviewFileDialog">
			<div class="preview_wrap">
				<video ref="previewVideo" style="width: 500px;height: 400px;" autoplay controls :src="curPreviewFileUrl"></video>
			</div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="closePreviewFileDialog">关 闭</el-button>
		  </span>
		</el-dialog>
  </div>
</template>
<script>
import Breadcrumb from '@/views/frontDesk/components/Breadcrumb.vue';
import { topicDeclareBtnRightControl } from '@/api/after/projectApplication.js';
import { getProjectListDetail } from '@/api/before/home';
export default {
  name: 'subjectResearchDetail',
  components: {
    Breadcrumb
  },
  data() {
    return {
      curPreviewFileUrl: '',//视频附件url
      filePreviewDialogVisible: false,//附件预览弹框
      id: 0,
      activeBreadcrumb: {},
      btnType: 'primary',
      isEnd: false, //是否截止
      data: {},
      userinfo: JSON.parse(sessionStorage.getItem('userInfo')),
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getData();
  },
  methods: {
    async getData() {
      // 判断三:同级别课题只能申报一个！
      const res = await getProjectListDetail(this.id)
      if (res.code == 200) {
        this.data = res.data;
        // 处理附件信息
        if (this.data.attachment) {
          this.data.attachment = this.data.attachment.split(',');
          this.data.annexName = this.data.annexName ? this.data.annexName.split(',') : [];
        } else {
          this.data.attachment = []
        }
        if (new Date().getTime() > new Date(this.data.declareEndTime).getTime()) {
          this.btnType = 'info';
          this.isEnd = true;
        }
      } else {
        this.$message.error(res.data)
      }
    },
     // 关闭文件预览对话框
		closePreviewFileDialog(){
		this.filePreviewDialogVisible = false
		this.$refs.previewVideo.pause();
		},
    // 查看附件
    downloadFile(id, name) {
      // window.open(`${this.uploadUrl}/upload/download?id=${id}&openStyle=1`, '_blank')
      // window.open(`https://view.officeapps.live.com/op/view.aspx?src=${this.uploadUrl}/upload/download?id=${id}&openStyle=1`,"_blank");
      if (/\.(png|jpeg|jpg|gif|PNG|JPEG|JPG|GIF)$/.test(name)) {
        window.open(`${this.uploadUrl}/upload/previewImage/${id}`, '_blank')
      } else if (/\.(doc|docx|DOC|DOCX)$/.test(name)) {
        window.open(`${this.uploadUrl}/upload/downloadPdf/${id}`, '_blank')
      } else if (/\.(mp4|rm|rmvb|3gp|avi|mpeg|mpg|mkv|dat|asf|wmv|flv|mov|ogg|ogm|RM|RMVB|3GP|AVI|MPEG|MPG|MKV|DAT|ASF|WMV|FLV|MOV|MP4|OGG|OGM)$/.test(name)) {
        // window.open(`${this.uploadUrl}/upload/previewVideo/${id}`, '_blank')// 视频
        this.curPreviewFileUrl = `${this.uploadUrl}/upload/previewVideo/${id}`
        this.filePreviewDialogVisible = true
      } else if (/\.(pdf|PDF)$/.test(name)) {
        window.open(`${this.uploadUrl}/upload/previewPdf/${id}`, '_blank')
      } else {
        window.open(`${this.uploadUrl}/upload/download?id=${id}&openStyle=1`, '_blank')
      }
    },
    // 去申报
    async toApplication() {
      let projectData = JSON.parse(JSON.stringify(this.data))
      projectData.attachment = projectData.attachment.join(',')
      sessionStorage.setItem('projectData', JSON.stringify(projectData))

      // 申报新课题判断
      if (this.userinfo) {
        // 判断一:普通教师才能申报
        // if (this.userinfo.roleId !== '') {
        //   this.$alert('只有普通教师才能申报！', '提示', {
        //     confirmButtonText: '确定',
        //     type: 'warning',
        //     callback: action => { }
        //   });
        //   return
        // }
        // 判断二:没有超过申报时间才能申报
        if (new Date(projectData.declareEndTime).getTime() <= Date.now()) {
          this.$alert('本次申报已截止！', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            callback: action => { }
          });
          return
        }
        // 判断三:同级别课题只能申报一个！
        const res = await topicDeclareBtnRightControl(projectData.id)
        if (res.code == 200) {
			if (res.data==1) {
				this.$alert('您当前已经申报过课题了，不允许重复申报！', '提示', {
					confirmButtonText: '确定',
					type: 'warning',
					callback: action => {}
				});
				return
			}else if (res.data==2) {
				this.$alert('您当前承担的课题还未结题，不允许申报新课题！', '提示', {
					confirmButtonText: '确定',
					type: 'warning',
					callback: action => {}
				});
				return
			}
          // if (!res.data) {
          //   this.$alert('您当前承担的课题还未结题，不允许申报新课题！', '提示', {
          //     confirmButtonText: '确定',
          //     type: 'warning',
          //     callback: action => { }
          //   });
          //   return
          // }
        } else {
          this.$message.error(res.data)
        }
      } else {
        this.$message.warning('还没登录，请先登录！')
        return
      }

      let url = '/backstage/projectApplicationProcess?projectId=' + this.data.id + '&limit=' + this.data
        .memberNumberLimit;
      this.$router.push(url);
    },
    toPage(url) {
      this.$router.push(url);
    }
  }
};
</script>
<style lang="scss" scoped>
.preview_wrap{
		height: 100%;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
/* 通用详情 */
.General-details,
.genDet-page {
  margin: 0 auto;
  max-width: 800px;
}

.genDet-att {
  border-bottom: 1px dashed #e3eaef;
}

.genDet-con {
  line-height: 2;
  text-indent: 2em;
}

.genDet-con img {
  margin: 0 auto 1rem;
  display: block;
  max-width: 100%;
}

.genDet-page {
  border-top: 1px solid #e3eaef;
}

.genDet-page .text-muted span {
  cursor: pointer;
}

.page_tit {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  display: inline-block;
}

.bottom_box {
  overflow: hidden;
}

.data_info .info_tit {
  display: inline-block;
  width: 110px;
  text-align: right;
  color: #00a0ed;
  font-weight: bold;
  font-size: 0.95rem;
}

.data_info .info_time {
  color: #ff0000;
  font-weight: bold;
  font-size: 0.95rem;
  cursor: pointer;
}

.btn_box {
  display: flex;
  justify-content: center;
}
</style>
